import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from '../../PaginationService';
import { messageService } from 'src/app/message.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { qmsService } from 'src/app/qms/qms.service';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';
import { DocumentViewerComponent } from 'src/app/support/document-viewer/document-viewer.component';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';

@Component({
  selector: 'app-document-issuance-history',
  templateUrl: './document-issuance-history.component.html',
  styleUrls: ['./document-issuance-history.component.scss']
})
export class DocumentIssuanceHistoryComponent implements OnInit {

  isProcessing = false;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  dmsDocumentIssuanceHistoryDataForGrid: any = [];
  dmsDocumentIssuanceHistoryDataForGridTemp: any = [];
  listOfDmsDocumentTypes: any = [];
  listOfDmsIssuanceTypes: any = [];
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  groupDataList: any = [];
  searchValue: any;
  dataTypeList: any = [];
  enableDownload: boolean = false;


  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  searchDocumentText: string = '';
  documentTypeSearchText: string = '';
  documentIssuanceSearchText: string = '';
  daysSearchText: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';

  isIssuanceFrom: any;
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, private readonly elem: ElementRef, public message: messageService, private readonly qmsService: qmsService, private readonly sessionTimeoutService: SessionTimeoutService) { }

  docIssuanceDays: any = [{
    valueExp: 7,
    displayExp: "7"
  }, {
    valueExp: 14,
    displayExp: "14"
  }, {
    valueExp: 30,
    displayExp: "30"
  }, {
    valueExp: 60,
    displayExp: "60"
  }, {
    valueExp: 90,
    displayExp: "90"
  }, {
    valueExp: 180,
    displayExp: "180"
  }, {
    valueExp: 181,
    displayExp: "More than 180"
  }]
  moduleName: any = 'DMS';
  searchBydocNo: any;
  searchBydocName: any;
  searchByFolder: any;
  getcallMethod() {
    this.isProcessing = true;
    this.dmsDocumentIssuanceHistoryDataForGrid = [];
    const data = {

      gridName: "DOCUMENT_ISSUANCE"
    }

    if (this.selectedSearchValue) {
      if (this.selectedSearchValue == "Document No.") {
        this.searchBydocNo = this.searchByDocNoOrName;
        this.searchBydocName = null
        this.searchByFolder = null;
      } else if (this.selectedSearchValue == "Document Name") {
        this.searchBydocNo = null;
        this.searchBydocName = this.searchByDocNoOrName
        this.searchByFolder = null;
      } else {
        this.searchBydocNo = null;
        this.searchBydocName = null;
        this.searchByFolder = this.selectedFolderId;
      }
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        let gridName: any = '';
        if (this.isIssuanceFrom !== "Document") {
          response.tableOrViewName = "DMS_MY_ISSUANCE_HISTORY_VW";
        }
        const data1: any = {

          gridName: "DOCUMENT_ISSUANCE",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          moduleName: this.moduleName,
          documentNo: this.searchBydocNo,
          documentName: this.searchBydocName,
          folderId: this.searchByFolder,
          documentTypeCode: this.searchByDocumentType ?? null,
          issuanceType: this.searchByIssuanceType ?? null,
          issuanceDays: this.searchByDays ?? null,
          issuedTo: this.searchByIssuedTo,
          issuedBy: this.searchByIssuedById,
          isPrintOrDownload: this.isPrintOrDownload,
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.dmsDocumentIssuanceHistoryDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let arr = [];
            if (data1.columnsListarray[data1.columnsListarray.length - 1].includes("\r")) {
              arr = data1.columnsListarray[data1.columnsListarray.length - 1].split("\r");
              data1.columnsListarray[data1.columnsListarray.length - 1] = arr[0];
            }

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              if (this.searchByIssuanceType == "Download Template") {
                if (data1.fieldColumnarray[p] == "Document Name") {
                  data1.fieldColumnarray[p] = "Template Name";
                }
              }
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.fieldColumnarray[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const type of this.dataTypeList ?? []) {
                  if (type.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = type.fieldType;
                    this.columnLists.fieldColumnarray[m].dataType = type.fieldType;
                  }
                }
              }

              for (const row of this.dmsDocumentIssuanceHistoryDataForGrid ?? []) {
                for (const type of this.dataTypeList ?? []) {
                  if (type.fieldType === 'CHECKBOX') {
                    const colName = type.columnName;
                    row[colName] = row[colName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
            });
            this.collectionSize = this.dmsDocumentIssuanceHistoryDataForGrid.length;
            this.totalPages = Math.ceil(this.dmsDocumentIssuanceHistoryDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }


  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.dmsDocumentIssuanceHistoryDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.dmsDocumentIssuanceHistoryDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.dmsDocumentIssuanceHistoryDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.dmsDocumentIssuanceHistoryDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.dmsDocumentIssuanceHistoryDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.dmsDocumentIssuanceHistoryDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.dmsDocumentIssuanceHistoryDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.dmsDocumentIssuanceHistoryDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.dmsDocumentIssuanceHistoryDataForGridTemp = this.dmsDocumentIssuanceHistoryDataForGrid;
      this.pager = this.paginationService.getPager(this.dmsDocumentIssuanceHistoryDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.dmsDocumentIssuanceHistoryDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.dmsDocumentIssuanceHistoryDataForGrid == undefined) {
        return this.dmsDocumentIssuanceHistoryDataForGrid;
      }
      if (!this.dmsDocumentIssuanceHistoryDataForGrid.length) {
        return this.dmsDocumentIssuanceHistoryDataForGrid;
      }
      if (filter) {
        this.dmsDocumentIssuanceHistoryDataForGridTemp = this.dmsDocumentIssuanceHistoryDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.dmsDocumentIssuanceHistoryDataForGridTemp = this.dmsDocumentIssuanceHistoryDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  counts: any;
  makeStickyColumns: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.dmsDocumentIssuanceHistoryDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.ISSUANCE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.dmsDocumentIssuanceHistoryDataForGrid.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }
  focusEmpty() {
    console.log();
  }
  ngOnInit() {

    this.isIssuanceFrom = this.message.isIssuanceFrom;

    // 🔹 Triggered from Home Page (value = "Home")
    if (this.isIssuanceFrom === "Home") {
      this.enableDownload = true;
    }

    this.isIssuanceFrom = this.message.isIssuanceFrom;
    if (this.isIssuanceFrom != 'Document') {
      this.searchByIssuedByName = localStorage.getItem('loggedUserName')
    }
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');

    /* this.selectedSearchValue = [{
      displayExp: "Document No.",
      valueExp: "documentNo"
    }] */

    this.selectedSearchValue = "Document No.";

    this.appService.getDocumentTypeListFromOneQmsDocumentTypesVw().subscribe((response: any) => {
      this.listOfDmsDocumentTypes = response;

      this.appService.getCodeListsByGroup("DOCUMENT_ISSUANCE_TYPE").subscribe((data: any) => {
        this.listOfDmsIssuanceTypes = data;

        this.selectBoxForDmsDocumentTypes();
        this.selectBoxForDmsIssuanceTypes();
        this.selectBoxeForDesignationCode();
        this.selectBoxeForDepartmentCode();
      })

    })

  }

  refreshGridData() {
    this.getcallMethod();
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  selectedSearchValue: any = null;
  dropDownForSearchValue: any = [{
    displayExp: "Document No.",
    valueExp: "Document No."
  }, {
    displayExp: "Document Name",
    valueExp: "Document Name"
  }, {
    displayExp: "Folder",
    valueExp: "Folder"
  }];

  displayLabelName: any = "Document No.";
  onSearchValueSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedFolderId = null;
    this.searchByDocNoOrName = null;
    if (this.selectedSearchValue == item.valueExp) {
      this.displayLabelName = item.displayExp;
    }

  }

  onSearchValueSelectOld(items: any) {
    this.searchByDocNoOrName = null;
  }

  searchByDocumentType: any = null;
  dmsDocumentTypeListDropdown: any = [];
  selectBoxForDmsDocumentTypes(): void {
    this.dmsDocumentTypeListDropdown = [];

    for (const docType of this.listOfDmsDocumentTypes ?? []) {
      this.dmsDocumentTypeListDropdown.push({
        valueExp: docType.documentTypeCode,
        displayExp: docType.documentTypeName
      });
    }
  }

  searchByIssuanceType: any = null;
  searchByDays: any = null;
  dmsIssuanceTypeListDropdown: any = [];
  selectBoxForDmsIssuanceTypes() {
    this.dmsIssuanceTypeListDropdown = [];
    for (const issuance of this.listOfDmsIssuanceTypes ?? []) {
      this.dmsIssuanceTypeListDropdown.push({
        valueExp: issuance.codelistCode,
        displayExp: issuance.codelistName
      });
    }
    this.dmsIssuanceTypeListDropdown = this.dmsIssuanceTypeListDropdown.concat({
      valueExp: "Revision History",
      displayExp: "Revision History"
    })
    this.dmsIssuanceTypeListDropdown = this.dmsIssuanceTypeListDropdown.concat({
      valueExp: "Download Template",
      displayExp: "Download Template"
    })
    this.dmsIssuanceTypeListDropdown = this.dmsIssuanceTypeListDropdown.concat({
      valueExp: "Original Document",
      displayExp: "Original Document"
    })
    this.dmsIssuanceTypeListDropdown = this.dmsIssuanceTypeListDropdown.concat({
      valueExp: "History Document",
      displayExp: "History Document"
    })
  }

  searchByDesignationCode: any = null;
  designationCodeDropdown: any = [];
  // --- Designation Code Dropdown ---
  selectBoxeForDesignationCode(): void {
    for (const item of this.dropDownForDesignationCode ?? []) {
      this.designationCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  searchByDepartmentCode: any = null;
  departmentCodeDropdown: any = [];
  selectBoxeForDepartmentCode(): void {
    for (const item of this.dropDownForDepartmentCode ?? []) {
      this.departmentCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  visibleSearchUsersPopup: MatDialogRef<TemplateRef<any>>;

  searchUsersPopupConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  searchByDocNoOrName: any;
  searchByIssuedTo: any;
  searchByIssuedById: any;
  isPrintOrDownload: any;
  searchByIssuedByName: any;
  popupTitle: any;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByemailAddress: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  searchUsersFunction() {
    this.searchManagerChildCheckBoxs = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.popupTitle = "Search Users";
    this.visibleSearchUsersPopup = this.dialog.open(this.searchUser, this.searchUsersPopupConfig);
  }

  searchManagerChildCheckBoxs: boolean = false;
  searchManagerDataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    for (const row of this.getOneQmsUsersVwDetailsTableData ?? []) {
      row.searchManagerChildCheckBoxs = isChecked;
    }
  }
  getSelectedUserId: any;
  getSelectedUserName: string;
  privvalue: any;
  draftUser: any = {};
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {

    this.getOneQmsUsersVwDetailsTableData.every((item: any) => { if (item.searchManagerChildCheckBoxs) { item.searchManagerChildCheckBoxs = false; } return true; })

    if (e.target.checked) {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.draftUser = listOfUsersVwDetails;
    } else {
      listOfUsersVwDetails.userChildCheckBox = false;
      this.draftUser = {};
    }
  }

  searchManagerGridDataFunction(): void {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode ?? null;
    this.departmentCodeValue = this.searchByDepartmentCode ?? null;

    const processedUserName = (this.searchByUserName ?? '').toUpperCase();
    this.searchByUserName ??= '';


    const data: Record<string, unknown> = {
      userName: processedUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByemailAddress,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "All"
    };
    this.appService.getOneQmsUsersVwDetails(data).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response.sort((m: { userName: string; }, n: { userName: string; }) => m.userName.trim().localeCompare(n.userName.trim()));
      this.isProcessing = false;
    })
  }

  resetSearchUserGridDataFunction() {
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.searchByIssuedById = null;
    this.searchByIssuedByName = null;
  }

  addUserNameFunction() {
    this.searchByIssuedById = this.draftUser.userId;
    this.searchByIssuedByName = this.draftUser.userName;
    this.visibleSearchUsersPopup.close();
  }

  cancelSearchUserFunction() {
    this.visibleSearchUsersPopup.close();
  }

  resetSearchDocumentFieldsFunction() {
    if (this.searchByDocNoOrName != undefined || this.searchByIssuedTo != undefined || this.searchByDocumentType ||
      this.searchByIssuanceType) {
      this.searchByDocNoOrName = undefined;
      this.searchByIssuedTo = undefined;
      this.searchByDocumentType = null;
      this.searchByIssuanceType = null;
      this.pager = [];
      this.pagedItems = [];
      this.dmsDocumentIssuanceHistoryDataForGrid = [];
    }
    this.searchByDays = null;

    this.isIssuanceFrom == 'Document' && (this.searchByIssuedByName = '');

    this.dmsDocumentIssuanceHistoryDataForGrid.length && ([this.dmsDocumentIssuanceHistoryDataForGrid, this.pagedItems] = [[], []]);
  }

  @ViewChild('destroyControlledCopyPopup', { static: true }) destroyControlledCopyPopup: TemplateRef<any>;
  visibleDestroyControlledCopyPopup: MatDialogRef<TemplateRef<any>>;
  destroyPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  destroyIssuanceId: any;
  openDestroyPopup(editRowData: any) {
    this.destoryComments = '';
    this.popupTitle = 'Destroy Controlled Copy Document';
    this.destroyIssuanceId = editRowData.ISSUANCE_ID;
    this.visibleDestroyControlledCopyPopup = this.dialog.open(this.destroyControlledCopyPopup, this.destroyPopupConfig);
  }

  destroyCommentsFieldValue: any;
  onFieldFocusout() {
    this.destroyCommentsFieldValue = document.getElementById('destroyComments-validation') as HTMLInputElement;

    if (this.destroyCommentsFieldValue != undefined) {
      if (this.destoryComments == "" || this.destoryComments == undefined) {
        this.destroyCommentsFieldValue.style.color = 'red';
      } else {
        this.destroyCommentsFieldValue.style.color = '';
      }
    }
  }

  destoryComments: any;
  doDestroyControlledCopyPopupFunction() {
    this.isProcessing = true;
    this.destroyCommentsFieldValue = document.getElementById('destroyComments-validation') as HTMLInputElement;
    if (this.destoryComments == "" || this.destoryComments == undefined) {
      this.destroyCommentsFieldValue.style.color = 'red';
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {
      let data = {

        issuanceId: this.destroyIssuanceId,
        status: 'Destroyed',
        comments: this.destoryComments,
      }
      this.appService.getIssuanceHistoryStatusProcedure(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDestroyControlledCopyPopup.close();
            this.getcallMethod();
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDestroyControlledCopyPopupFunction() {
    this.visibleDestroyControlledCopyPopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  openAuditTrail(viewType: any, issuance: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : issuance.ISSUANCE_ID;
    this.auditTrail.gridName = 'DOCUMENT_ISSUANCE';
    if (this.isIssuanceFrom != "Document") { this.auditTrail.isTrailFromHomePage = true; }
    this.auditTrail.report_And_Popup_Name = 'Issuance History Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(issuance);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Issuance History Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {

    this.gridReorderComponent.reordercall(this.reportObj.gridName, "DMS_DOCUMENT_ISSUANCE_HISTORY_VW", this.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  @ViewChild('viewPopup', { static: true }) viewPopup: TemplateRef<any>;
  visibleViewPopup: MatDialogRef<TemplateRef<any>>;

  viewPopupConfig = {
    width: '100%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  viewerData: any = {};
  @ViewChild(DocumentViewerComponent)
  documentViewerComponent!: DocumentViewerComponent;

  docViewer!: DocViewerConfig;

  downloadDocuments(list: any, columnName: any) {
    this.isProcessing = true;

    const isZip = list.DOWNLOADED_FILE_EXTN?.toLowerCase() === "zip";
    const hasDownloadPrivilege = this.message.isDocumentDownloader;

    const docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    };

    // 🔹 ZIP condition (anywhere)
    if (isZip) {
      if (!hasDownloadPrivilege) {
        this.isProcessing = false;
        setTimeout(() => {
          this.showSnackBar('You are not permitted to download ZIP files. The user does not have the Document Downloader privilege.', 'E');
        },);
        return;
      }


      const fileName = list.DOWNLOADED_FILE_NAME.replaceAll(".", "_");

      this.appService.downloadIssuanceFile(
        list.ISSUANCE_ID,
        fileName
      );

      this.isProcessing = false;
      return;
    }

    if (list.tablevwname === "DMS_MY_ISSUANCE_HISTORY_VW") {
      docObj.tableView = "DMS_DOCUMENT_ISSUANCE_HISTORY_VW";
      docObj.columnName = "DOWNLOADED_FILE";
    }

    // 🔹 NON-ZIP case → ALWAYS preview using viewer
    this.appService.getDocumentToViewAudit(docObj).subscribe({
      next: (response: any) => {
        const header = response.headers.get('content-type');
        const blob = new Blob([response.body], { type: header });

        this.docViewer = {
          blob,
          doc: {
            body: blob,
            contentType: header,
            extn: list.DOWNLOADED_FILE_EXTN
          },
          docName: list.DOWNLOADED_FILE_NAME,
          docExtension: list.DOWNLOADED_FILE_EXTN,
          isFromOnlyPreview: !hasDownloadPrivilege || !this.enableDownload
        };

        setTimeout(() => {
          this.documentViewerComponent?.openPopUp();
        }, 100);
      },
      error: () => {
        this.snackBar.open('Could not load document.', 'Close', { duration: 3000 });
      },
      complete: () => (this.isProcessing = false)
    });
  }


  cancelViewPopup() {
    this.visibleViewPopup.close();
  }

  @ViewChild('selectFolderPopup', { static: true }) selectFolderPopup: TemplateRef<any>;
  visibleSelectFolderPopup: MatDialogRef<TemplateRef<any>>;

  selectFolderPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  model = {
    documentData: {},
  };
  selectedFolderForCreateDoc: any = {};
  documentDataForDocType: any = {
    expirationDate: Date
  }

  selectedFolderId: any;
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;
    this.selectedFolderId = this.selectedFolderForCreateDoc.folderId;
  }

  cancelSelectFolderFunc() {
    this.visibleSelectFolderPopup.close();
  }

  searchFolderFunc() {
    this.selectedFolderId = null;
    this.searchByDocNoOrName = null;
    this.visibleSelectFolderPopup = this.dialog.open(this.selectFolderPopup, this.selectFolderPopupConfig);
  }

  chooseFolderFunc() {
    this.searchByDocNoOrName = this.selectedFolderForCreateDoc.folderName;
    this.visibleSelectFolderPopup.close();
  }

  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }
}
